import { render, staticRenderFns } from "./MovieOngoing.vue?vue&type=template&id=16067011&scoped=true"
import script from "./MovieOngoing.vue?vue&type=script&lang=js"
export * from "./MovieOngoing.vue?vue&type=script&lang=js"
import style0 from "./MovieOngoing.vue?vue&type=style&index=0&id=16067011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16067011",
  null
  
)

export default component.exports